import Vue from "vue";
import axios from "axios";
import router from "@/router";
import { store } from "@/store";
import VueAxios from "vue-axios";

let axiosInstance = axios.create({ baseURL: "/api/" });
const token = localStorage.getItem("auth_token");

axiosInstance.defaults.headers.common["authorization"] = "Bearer " + token;
// axiosInstance.defaults.headers.post["Content-Type"] = "multipart/form-data";
axiosInstance.defaults.headers.post["Content-Type"] = "application/json";
axiosInstance.defaults.headers.put["Content-Type"] = "application/json";
axiosInstance.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axiosInstance.defaults.headers.common["X-Requested-KEY"] =
    "74be16979710d4c4e7c6647856088456";

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (isNetworkError(error)) {
            store.commit("showSnackbar", {
                text: "Check your network connection.",
                stateType: "error",
                show: true
            });
        }
        if (error.response && error.response.status === 401) {
            localStorage.removeItem("auth_token");
            localStorage.removeItem("currentUser");
            delete axiosInstance.defaults.headers.common["Authorization"];
            store.commit("AuthModule/setToken", false);
            router.replace("/auth/login");
        } else {
            let text = error.msg || error.message || error.response.data.message || error;
            store.commit("showSnackbar", {
                text: text,
                stateType: "error",
                show: true
            });
        }

        return Promise.reject(error);
    }
);

function isNetworkError(err) {
    return !!err.response;
}
window.Vue = Vue;
window.axios = axiosInstance;
Vue.use(VueAxios, window.axios);
